const messages: Record<string, string> = {
	'loader.loading': 'Loading data ...',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'connectionError.title': 'Connection error',
	'connectionError.description': 'Connection error. Please upload picture again.',
	'mainError.tryAgain': 'Try again',
	'landing.headline.policyCheck': 'Welcome',
	'landing.paragraph': 'You are just two steps away from finishing the digital vehicle inspection',
	'landing.stepDescription.fourAdditionalPictures': 'Take the required photos',
	'landing.stepDescription.feedback': 'Let us know how it went',
	'landing.termsAndConditionsLinkDescription':
		'By pressing "Start" you are accepting our <tclink>Terms and conditions.</tclink>',
	'button.start': 'Start',
	'button.close': 'OK',
	'landing.aboutPolicyCheck': 'Back',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of 8 simple steps.',
	'chooseLang.headline': 'Choose your preferred language',
	'blockedByDevice.headline': 'PolicyCheck does not support desktop browsers',
	'blockedByDevice.description':
		'PolicyCheck is using a desktop browser.<br>The PolicyCheck platform performs documenting cases using mobile devices. To continue, please run the PolicyCheck link on a mobile device',

	'vehicleImages.overviewPhotos': 'Vehicle overview',
	'vehicleImages.description':
		'Take photos of the vehicle from all angles. The license plate should be clearly visible in all of them.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Front left diagonal',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Rear left diagonal',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Rear right diagonal',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Front right diagonal',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Photo example',
	'button.next': 'Next',

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Front left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Rear left diagonal example photo',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Rear right diagonal example photo',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Front right diagonal example photo',

	'imageRecognitionMismatchModal.headline': 'Let’s check if the photos you added are correct',
	'button.continue': 'CONTINUE',
	'button.backchangeImage': 'RETAKE THE PHOTO',

	'vehicleImages.leftFrontOverview': 'Front left diagonal',
	'vehicleImages.leftRearOverview': 'Rear left diagonal',
	'vehicleImages.rightRearOverview': 'Rear right diagonal',
	'vehicleImages.rightFrontOverview': 'Front right diagonal',
	'button.changeImage': 'RETAKE THE PHOTO',

	'completeVehicleImagesModal.headline': 'Missing photos',
	'completeVehicleImagesModal.description': 'Please add the following photographs:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Front left diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Rear left diagonal',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Rear right diagonal',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Front right diagonal',
	'button.ok': 'OK',

	'fourPerspectivesExampleModal.headline.first': 'Front left diagonal example photo',
	'fourPerspectivesExampleModal.headline.second': 'Rear left diagonal example photo',
	'fourPerspectivesExampleModal.headline.third': 'Rear right diagonal example photo',
	'fourPerspectivesExampleModal.headline.fourth': 'Front right diagonal example photo',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'button.prev': 'Back',
	'fourAdditionalPictures.title': 'Additional information',
	'fourAdditionalPictures.overallDashboard.title': 'Dashboard',
	'fourAdditionalPictures.overallDashboard.description':
		'Take a photo showing a complete dashboard of the vehicle.',
	'fourAdditionalPictures.mileage.title': 'Mileage',
	'dashboardMileage.dashboard.paragraph':
		'Take a photo of the vehicle odometer with the current mileage visible. If you have a digital display, please turn it on.',
	'dashboardMileage.paragraph.first': 'Enter the current mileage.',
	'dashboardMileage.input.error': 'Please enter the current mileage of the vehicle',
	'dashboardMileage.placeholder': 'Current mileage',
	'fourAdditionalPictures.windshield.title': 'Windshield',
	'fourAdditionalPictures.windshield.description':
		'Take a detailed photo of the vehicle’s windshield.',
	'fourAdditionalPictures.vin.title': 'VIN number',
	'fourAdditionalPictures.vin.description':
		'Take a photo of the vehicle’s VIN number. It can be found on the driver’s door seal or in the bottom left corner of the windshield.',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Dashboard example photo',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Mileage example photo',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Windshield example photo',
	'fourAdditionalPictures.vin.exampleModalTitle': 'VIN number example photo',

	'imageRecognitionMistmatchModal.headline': 'Let’s check if the photos you added are correct',
	'completeFourAdditionalPicturesModal.headline': 'Missing photos',
	'completeFourAdditionalPicturesModal.description': 'Please include the following photographs:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Dashboard',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Mileage',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Windshield',
	'completeFourAdditionalPicturesModal.hasVINImage': 'VIN number',
	'completeDashboardMileageModal.hasValidMileage':
		'Please enter the current mileage of the vehicle',

	'mismatchModal.enteredMileage': 'Entered mileage',

	'fourAdditionalPicturesExampleModal.headline.first': 'Dashboard example photo',
	'fourAdditionalPicturesExampleModal.headline.second': 'Mileage example photo',
	'fourAdditionalPicturesExampleModal.headline.third': 'Windshield example photo',
	'fourAdditionalPicturesExampleModal.headline.fourth': 'VIN number example photo',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',

	'upload.message': 'Your data is being uploaded. This process can take several minutes.',

	'feedback.headline.policyCheck': 'All pictures were received successfully!',
	'feedback.rating.policyCheck': 'How would you rate your experience with the app?',
	'feedback.yourOpinion': 'Any comments? Let us know!',

	'feedback.button.send': 'Submit',
	'feedback.comment.placeholder': 'Add your comment',

	'thanks.headline.first': 'Thank you for feedback!',
	'waitForAudit.thankYou': 'Inspection process is already sucessfully finished. Thank you!',

	'thanks.paragraph.first': ' ',
	'overallDashboardImage.title': 'Dashboard',
	'overallDashboardImage.headline': 'Dashboard',
	'dashboardMileage.dashboard.title': 'Mileage',
	'windshieldImage.title': 'Windshield',
	'windshieldImage.headline': 'Windshield',
	'vinPicture.headline': 'VIN number',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',

	'approval.description':
		'Check if the bank account number given below is correct. If so, confirm the estimate and the above amount will be transferred to your account.',
	'approval.lacquerCosts': 'Paintwork',
	'button.deleteImage': 'Delete the photo',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration certificate',
	'completeWindshieldImageModal.hasWindshieldImage': 'Photo of the windshield',
	'damageImages.additionalImages': 'Additional photos of the damages',
	'damageImages.description':
		'Add at least {imageCount, number} damage {imageCount, plural, one {photo of each damage} other {photos of each damage. Photos should be taken from different distances (zoom-in/whole element)}}. Important: the damage should be fully visible',
	'damageImages.optionalDamageImages': 'Optionally, add more photos showing the damages.',
	'feedback.description': '',
	'feedback.headline': 'Pictures received successfully!',
	'feedback.rating': 'How do you rate the claim settlement with EasyClaim?',
	'landing.dataPrivacyLink': 'By proceeding, you are accepting our terms and conditions.',
	'landing.stepDescription.additionalDocuments': 'Dodaj zdjęcie oświadczenia sprawcy',
	'landing.stepDescription.damageDescription': 'Opisz uszkodzenia',
	'landing.stepDescription.vinPicture': 'Dodaj zdjęcie numeru VIN znajdującego się na pojeździe',
	'landing.termsAndConditionsLink': 'By proceeding, you are accepting our terms and conditions.',
	'payout.headline.first': 'Bank account number',
	'payout.headline.second': 'Account holder',
	'payout.headline.third': 'Account number',
	'review.paragraph.first':
		'Make sure that all the data is entered, then click " Complete". You will receive a summary of the entered data.',
	'review.stepDescription.vehicleFrontPerspectiveImage':
		'Pictures of the front-left of the vehicle',
	'review.stepDescription.vehicleLeftPerspectiveImage':
		'Pictures of the front-right of the vehicle',
	'review.stepDescription.vehicleRearPerspectiveImage': 'Pictures of the rear-right of the vehicle',
	'review.stepDescription.vehicleRightPerspectiveImage': 'Pictures of the rear-left of the vehicle',
	'vehicleImages.details.first': 'The front-left of the vehicle',
	'vehicleImages.details.fourth': 'The rear-right of the vehicle',
	'vehicleImages.details.rearright':
		'Take a photo of the vehicle with the whole rear and right side. The license plate should be readable.',
	'vehicleImages.details.second': 'The rear-left of the vehicle',
	'vehicleImages.details.third': 'The front-right of the vehicle',
	'vehicleImagesExampleModal.headline.first': 'Vehicle overview photos – an example',

	'waitForAudit.description.damageFound': ' ',
	'waitForAudit.description.damageNotFound': ' ',

	'button.reverse': 'Keep Photo Milege',
	'button.confirm': 'Confirm My Mileage',
	'mileageModal.headline': "Let's check if the mileage value you added is correct",
	'mileageModal.paragraph':
		'The photo mileage value differs from that entered in the field. Change the value or confirm to proceed if you find that the mileage you entered is correct.',
	'mileageModal.insertedMileagePlaceholder': 'Mileage value that you entered',
	'mileageModal.pictureMileage': 'Mileage value taken from the picture',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
